import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import fb from '@/firebaseConfig';

import { setToken, setTokenRefreshCall } from '@/helpers/http';



const VueAnalytics = require('vue-analytics').default;  // needs tpye defs rea;;y///

// import 'vuetify/dist/vuetify.min.css'//see if this allows us to remove link ref

Vue.config.productionTip = true;

Vue.use(VueAnalytics, {
    id: 'UA-126137717-1', router, autoTracking: {
        exception: true,
    }, // debug: { enabled: true },
});

let app: Vue;

fb.auth.onIdTokenChanged((firebaseUser) => {
    if (firebaseUser) {
        firebaseUser.getIdToken().then((token) => {
            setToken(token);
        });
    }
});

fb.auth.onAuthStateChanged((firebaseUser) => {
    if (!app) {
        app = new Vue({
            el: '#app',
            router,
            store,
            render: (h) => h(App),
            created() {
                if (firebaseUser) {
                    store.dispatch('autoSignIn', firebaseUser);
                }
            },
        });
    }
});
